import Handlebars from "handlebars/dist/handlebars";

export default function (el) {
    let elObj = $(el);
    if (elObj.length) {
        return Handlebars.compile($(el).html());
    }
    return '';
}